import React from "react";
import classes from "../styles/style.module.css";
import CourseImg from "../../../assets/images/Roshana/courseInformation.svg";

const CourseInformation = () => {
  return (
    <div className="customContainer">
      <div className={classes.hintContainer}>
        <div className={classes.hintHeader}>
          <img src={CourseImg} alt="courseInfromationImg" />
        </div>
        <p className={classes.hintFirstTitle}>خلاصه کتاب</p>
        <p className={classes.hintSecondTitle}>
          توضیحاتی مختصر درباره
          <br /> ‌ این کتاب
        </p>
        <p className={classes.hintText}>
          «بی‌چهرگان» تازه‌ترین رمان تاریخی علیرضا محمودی ایرانمهر است؛ روایتی که خواننده را به روزگار پررمزوراز دوره اشکانیان می‌برد؛ جایی که مرز میان تاریخ، اسطوره و خیال به‌طرزی هنرمندانه در هم می‌آمیزد. نویسنده با تکیه بر اتفاقات تاریخی و شخصیت‌ها، داستانی پرکشش خلق کرده که هم ماجراجویی است و هم جست‌وجویی برای یافتن هویت، معنا و ریشه‌های ایران.         <br />
          <br/>
          «بی‌چهرگان» تنها یک رمان تاریخی نیست؛ سفری است به دنیای انسان‌هایی که نامشان در تاریخ گم شده، اما سرنوشت‌شان می‌تواند سرنوشت یک تمدن را تغییر دهد. اگر به داستان‌های خوش‌ریتم، شخصیت‌پردازی عمیق و روایت‌هایی علاقه دارید که گذشته را با نگاهی تازه و امروزی بازآفرینی می‌کنند، این کتاب تجربه‌ای متفاوت و فراموش‌نشدنی برای شما خواهد بود.        <br />
        </p>
      </div>
    </div>
  );
};

export default CourseInformation;
